function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

!function (e, n) {
  "object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) && "undefined" != typeof module ? module.exports = n() : "function" == typeof define && define.amd ? define(n) : e.CookieMgmt = n();
}(this, function () {
  "use strict";

  var e = function e(_e, n) {
    return _e ? function (t, o) {
      var i = _e + "=" + t + ";";
      return o && (i += " expires=" + o + ";"), i += " path=" + n, document.cookie = i, i;
    } : null;
  };

  return function (n) {
    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "/";
    if (void 0 === n || null === n) return null;
    var o = e(n, t);
    return {
      createCookie: function createCookie(e, n) {
        o(e, function (e) {
          if (!e) return null;
          var n = new Date();
          return n.setTime(n.getTime() + 24 * e * 60 * 60 * 1e3), n.toGMTString();
        }(n));
      },
      deleteCookie: function deleteCookie() {
        o("nil", "Thu, 01 Jan 1970 00:00:01 GMT");
      },
      getValue: function getValue() {
        return function (e) {
          if (document.cookie.length <= 0) return "";
          var n = document.cookie.indexOf(e + "=");
          if (-1 === n) return "";
          n = n + e.length + 1;
          var t = document.cookie.indexOf(";", n);
          return t = -1 === t ? document.cookie.length : t, unescape(document.cookie.substring(n, t));
        }(n);
      }
    };
  };
});